import { EndorsementChainType } from '@/constants/etr/index';
export function checkType(type) {
    const typeMessages = {
      [EndorsementChainType.INITIAL]: "Document has been issued",
      [EndorsementChainType.TRANSFER_HOLDER]: "Transfer holdership",
      [EndorsementChainType.TRANSFER_BENEFICIARY]: "Endorse change of ownership",
      [EndorsementChainType.TRANSFER_OWNERS]: "Transfer ownership",
      [EndorsementChainType.SURRENDERED]: "Document surrendered to issuer",
      [EndorsementChainType.SURRENDER_REJECTED]: "Issuer rejected the surrender",
      [EndorsementChainType.SURRENDER_ACCEPTED]: "Shredded",
      [EndorsementChainType.REJECT_TRANSFER_HOLDER]: "Reject transfer holdership",
      [EndorsementChainType.REJECT_TRANSFER_OWNERS]: "Reject transfer ownership",
      [EndorsementChainType.REJECT_TRANSFER_BENEFICIARY]: "Reject endorse change of ownership",
      [EndorsementChainType.RETURNED_TO_ISSUER]: "Document surrendered to issuer",
      [EndorsementChainType.RETURN_TO_ISSUER_REJECTED]: "Issuer rejected the surrender",
      [EndorsementChainType.RETURN_TO_ISSUER_ACCEPTED]: "Shredded",
    }
  
    return typeMessages[type] || "";
  }